<template>
  <el-select
    v-loading="loading"
    v-model="dirSelected"
    @change="hanldeSelection()"
    placeholder="Gerencias"
    :size="size"
    clearable
    filterable
    :disabled="isItDisabled"
  >
    <el-option
      v-for="item in directions"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
import { formatArrayToElSelect } from "@/utils";

export default {
  name: "DirectionSelector",
  props: {
    size: {
      type: String,
      default: "mini"
    },
    initialDirection: {
      type: Number,
      default: 0,
      required: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.loading = true;
    this.$http
      .get("/api/Directions/DirectionsByCompany", {
        params: {
          company: this.currentCompany
        }
      })
      .then(({ data }) => {
        this.directions = formatArrayToElSelect(data);
        if (this.initialDirection !== 0) {
          this.dirSelected = this.DisplayInitialValue;
        }
        this.$emit("directionData", this.directions);
      })
      .finally(() => (this.loading = false));
    //this.dirSelected = this.currentUser.DireccionID;
  },
  data() {
    return {
      dirSelected: "",
      directions: [],
      loading: false
    };
  },
  updated() {
    if (this.initialDirection !== 0 && this.dirSelected === "") {
      this.dirSelected = this.initialDirection;
    }
  },
  computed: {
    DisplayInitialValue() {
      if (this.initialDirection !== 0) {
        return this.initialDirection;
      } else {
        return this.dirSelected;
      }
    },
    isItDisabled() {
      return this.isDisabled;
    }
  },
  methods: {
    hanldeSelection() {
      if (this.dirSelected) {
        this.$emit("selection-change", this.dirSelected);
      } else {
        this.$emit("selection-change", 0);
      }
    }
  },
  watch: {
    initialDirection(val) {
      this.dirSelected = val;
    }
  }
};
</script>

<style></style>
